var exports = {
  "WB": "GroupDMWelcomeSection.module__welcomeSection___VngwX3",
  "rZ": "GroupDMWelcomeSection.module__profileSection___VngwX3",
  "hv": "GroupDMWelcomeSection.module__groupName___VngwX3",
  "Yh": "GroupDMWelcomeSection.module__welcomeText___VngwX3",
  "o1": "GroupDMWelcomeSection.module__actions___VngwX3",
};

module.exports = exports;
